<template>
    <div>
        <div class="mb-2">
            <edit-invoice-button
                class="mr-2"
                :invoiceId="data.id"
                type="sales"
            />
            <mark-invoice-as-paid-button
                    v-if="invoiceIsPayable"
                    class="mr-2"
                    :invoiceId="data.id"
                    invoiceType="sales"
            />
            <sales-invoice-reminder-button
                    v-if="invoiceIsRemindable"
                    class="mr-2"
                    :invoiceId="data.id"
                    :name="data.name"
            />
        </div>
        <div>
            <resend-invoice-button
                :invoiceId="data.id"
                class="mr-2"
            />
            <create-credit-invoice-button
                    v-if="invoiceIsCreditable"
                    :invoiceId="data.id"
                    class="mr-2"
            />
            <book-invoice-button
                    :invoiceId="data.id"
                    type="sales"
                    v-if="$can('book-invoices')"
            />
        </div>
    </div>
</template>

<script>
    import {
        CreateCreditInvoiceButton,
        ResendInvoiceButton,
        SalesInvoiceReminderButton,
        EditInvoiceButton,
        BookInvoiceButton
    } from '~/components/buttons'

    export default {
        name: 'actions',
        props: ['data', 'index'],
        components: {
            ResendInvoiceButton,
            CreateCreditInvoiceButton,
            SalesInvoiceReminderButton,
            EditInvoiceButton,
            BookInvoiceButton,
        },

        data() {
            return {
                invoiceType: 'sales',
            }
        },

        computed: {
            invoiceIsPayable() {
                return config.invoices.payable_statusses[this.invoiceType].includes(this.data.status)
            },
            invoiceIsRemindable() {
                return config.invoices.remindable_statusses.includes(this.data.status) && !this.data.credit_for
            },
            invoiceIsCreditable() {
                return config.invoices.creditable_statusses.includes(this.data.status) && !this.data.credit_for
            }
        },
    }
</script>

<style lang="scss" scoped>
</style>
